/**
 * Helper: Convert
 * -----------------------------------------------------------------------------
 * Convert strings into different cases.
 * - Add in alphabetical order.
 *
 */

/**
 * Convert a handle or snake_case into sentence case.
 * @param {String} string - String to convert.
 * @returns {String}
 */
export function convertHandleToSentenceCase(string) {
  if (!string) {
    return ''
  }

  return string
    .replace(/[-_]/g, ' ')
    .toLowerCase()
    .trim()
}

/**
 * Convert a string into camelCase.
 * @param {String} string - String to convert.
 * @returns {String}
 */
export function convertToCamelCase(string) {
  if (!string) {
    return ''
  }

  return string
    .replace(
      /.\b(?<word>\w)/g,
      (_, $1) => {
        return $1.toUpperCase()
      },
    )
    .replace(/[\s:'"]/g, '')
    .replace(
      /^(?<rest>.)/u,
      (_, $1) => {
        return $1.toLowerCase()
      },
    )
}

/**
 * Convert a string into handle (kebab-case).
 * @param {String} string - String to convert.
 * @returns {String}
 */
export function convertToHandle(string) {
  if (!string) {
    return ''
  }

  return string && replaceDiactirics(string)
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((part) => part.toLowerCase())
    .join('-')
}

/**
 * Convert a string into PascalCase.
 * @param {String} string - String to convert.
 * @return {String}
 */
export function convertToPascalCase(string) {
  if (!string) {
    return ''
  }

  return string
    .trim()
    .replace(
      /(?<firstLetter>\w)(?<rest>\w*)/g,
      (_, $1, $2) => {
        return $1.toUpperCase() + $2.toLowerCase()
      },
    )
    .replace(/-/g, '')
    .replace(/\s/g, '')
}

function replaceDiactirics(string) {
  const map = {
    a: 'á|à|ã|â|ä|ǎ|å|ā|À|Á|Ã|Â|Ä|Ǎ|Å|Ā',
    ae: 'æ|Æ',
    e: 'é|è|ê|ë|ě|ẽ|ē|ė|ę|É|È|Ê|Ë|Ě|Ẽ|Ē|Ė|Ę',
    i: 'í|ì|î|ï|ǐ|ĩ|ī|į|Í|Ì|Î|Ï|Ǐ|Ĩ|Ī|Į',
    o: 'ó|ò|ô|õ|ö|ǒ|o|ø|õ|ō|Ó|Ò|Ô|Õ|Ö|Ǒ|Ø|Õ|Ō',
    oe: 'œ|Œ',
    u: 'ú|ù|û|ü|ǔ|ũ|ū|ű|ů|Ú|Ù|Û|Ü|Ǔ|Ũ|Ū|Ű|Ů',
    c: 'ç|ć|č|ċ|Ç|Ć|Č|Ċ',
    n: 'ñ|ń|ņ|ň|Ñ|Ń|Ņ|Ň',
  }

  let str = string

  for (const key in map) {
    str = str.replace(new RegExp(map[key], 'g'), key)
  }

  return str
}
